import { useState, useEffect } from "react"
import {dateTimePrint} from '../../common/methods/CommonUtil'

function OfferListTopData(props) {
  const [dateStr,setDateStr] = useState(0)

  useEffect(() => {
    let propsdate = props.date;
    let _date = props.date.split('/');
    //YYYY/MM/DDのフォーマットにする
    if(_date.length == 2) propsdate += '/1';
    if(_date[2] === undefined && _date[2] === '') propsdate += '1';
    let date = new Date(propsdate);
    setFormatDateStr(date);
  }, [props])
  
	const setFormatDateStr = (date) => {
    setDateStr(dateTimePrint(props.language, date , 'YYYYMM'));
	}

  return (
    dateStr
  )
}

export default OfferListTopData
